import React, { useEffect, useState } from 'react';
import { ShieldCheck, Zap } from 'lucide-react';
export function PurchaseSection() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 58,
    seconds: 3
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  return <section id="compra" className="py-24 px-4 sm:px-6 lg:px-8 bg-[#142014] scroll-mt-10" data-id="element-84">
      <div className="max-w-4xl mx-auto" data-id="element-85">
        <div className="bg-gradient-to-b from-[#243824] to-[#1a2e1a] rounded-3xl p-8 md:p-12 border-2 border-[#c8e6c9] shadow-[0_0_50px_rgba(200,230,201,0.1)] relative overflow-hidden" data-id="element-86">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-[#c8e6c9] text-[#1a2e1a] font-bold px-8 py-2 rounded-b-xl uppercase tracking-widest text-sm" data-id="element-87">
            Oferta Especial - Hoy
          </div>

          <div className="text-center mt-8 mb-10" data-id="element-88">
            <h3 className="text-2xl md:text-3xl font-bold text-[#faf5e8] mb-4" data-id="element-89">
              Sistema completo de entrenamiento + 6 tomos + bonos gratis
            </h3>
            <p className="text-[#a8c5a8] text-lg" data-id="element-90">
              Acceso inmediato al contenido digital
            </p>
          </div>

          <div className="flex flex-col items-center justify-center mb-12" data-id="element-91">
            <p className="text-[#a8c5a8] text-2xl line-through mb-2 font-medium" data-id="element-92">
              Precio anterior: $49.990
            </p>
            <div className="flex items-start gap-2" data-id="element-93">
              <span className="text-[#c8e6c9] text-4xl font-bold mt-2" data-id="element-94">$</span>
              <span className="text-[#c8e6c9] font-heading text-7xl md:text-8xl font-black leading-none" data-id="element-95">
                19.990
              </span>
            </div>
          </div>

          <div className="bg-red-900/20 border border-red-500/30 rounded-xl p-6 mb-10 text-center max-w-md mx-auto" data-id="element-96">
            <p className="text-red-400 font-bold uppercase tracking-wider mb-4 text-sm" data-id="element-97">
              La oferta termina en:
            </p>
            <div className="flex justify-center gap-4 md:gap-6" data-id="element-98">
              <div className="flex flex-col items-center" data-id="element-99">
                <span className="font-heading text-4xl md:text-5xl font-black text-[#faf5e8]" data-id="element-100">
                  {formatTime(timeLeft.hours)}
                </span>
                <span className="text-xs text-[#a8c5a8] uppercase mt-1" data-id="element-101">
                  Horas
                </span>
              </div>
              <span className="font-heading text-4xl md:text-5xl font-black text-red-500/50" data-id="element-102">
                :
              </span>
              <div className="flex flex-col items-center" data-id="element-103">
                <span className="font-heading text-4xl md:text-5xl font-black text-[#faf5e8]" data-id="element-104">
                  {formatTime(timeLeft.minutes)}
                </span>
                <span className="text-xs text-[#a8c5a8] uppercase mt-1" data-id="element-105">
                  Minutos
                </span>
              </div>
              <span className="font-heading text-4xl md:text-5xl font-black text-red-500/50" data-id="element-106">
                :
              </span>
              <div className="flex flex-col items-center" data-id="element-107">
                <span className="font-heading text-4xl md:text-5xl font-black text-red-400" data-id="element-108">
                  {formatTime(timeLeft.seconds)}
                </span>
                <span className="text-xs text-red-400/70 uppercase mt-1" data-id="element-109">
                  Segundos
                </span>
              </div>
            </div>
          </div>

          <div className="text-center" data-id="element-110">
            <a href="https://checkout.ebookpoint.shop/cart/59423210209361:1" className="inline-flex flex-col items-center justify-center w-full md:w-auto bg-[#2e7d32] hover:bg-[#388e3c] text-[#faf5e8] font-heading font-black text-2xl md:text-3xl py-6 px-12 rounded-2xl shadow-[0_0_30px_rgba(46,125,50,0.3)] transition-all transform hover:scale-105 hover:shadow-[0_0_40px_rgba(46,125,50,0.5)] uppercase tracking-wide group" data-id="element-111">
              <span data-id="element-112">Comprar Ahora</span>
              <span className="text-sm font-medium text-green-100 mt-1 normal-case tracking-normal opacity-90 group-hover:opacity-100" data-id="element-113">
                Solo por $19.990
              </span>
            </a>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-6 text-[#a8c5a8] text-sm" data-id="element-114">
              <div className="flex items-center gap-2" data-id="element-115">
                <ShieldCheck className="w-5 h-5 text-[#4caf50]" data-id="element-116" />
                <span data-id="element-117">Compra 100% segura</span>
              </div>
              <div className="hidden sm:block w-1 h-1 bg-green-800 rounded-full" data-id="element-118" />
              <div className="flex items-center gap-2" data-id="element-119">
                <Zap className="w-5 h-5 text-[#c8e6c9]" data-id="element-120" />
                <span data-id="element-121">Producto digital • Acceso inmediato</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}